import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, NgZone, OnDestroy, ViewChild } from '@angular/core';

// Wraps tall content (a long comment, say). Past max_height it is cut off with a fade, and a "View More" sits over the fade;
// once opened it can be closed again with "View Less". Content that fits is shown as it is, with nothing added.
@Component({
  selector: 'app-collapsible',
  template: `
    <div class="collapsible-box" [style.max-height]="(expanded || !overflowing) ? 'none' : max_height + 'px'">
      <div #inner><ng-content></ng-content></div>
      <div *ngIf="overflowing && !expanded" class="collapsible-fade"
        [style.background]="'linear-gradient(to bottom, rgba(255,255,255,0), ' + fade_colour + ' 75%)'">
        <a role="button" class="collapsible-toggle" (click)="expanded = true"><i class="fa-solid fa-chevron-down"></i> View More <i class="fa-solid fa-chevron-down"></i></a>
      </div>
    </div>
    <div *ngIf="overflowing && expanded" class="text-center">
      <a role="button" class="collapsible-toggle" (click)="expanded = false"><i class="fa-solid fa-chevron-up"></i> View Less <i class="fa-solid fa-chevron-up"></i></a>
    </div>
  `,
  styles: [`
    .collapsible-box { position: relative; overflow: hidden; }
    .collapsible-fade { position: absolute; left: 0; right: 0; bottom: 0; height: 4.5rem; display: flex; align-items: flex-end; justify-content: center; padding-bottom: 0.1rem; }
    .collapsible-toggle { color: #0d9bd8; cursor: pointer; font-size: 0.9rem; font-weight: 700; text-decoration: none; }
    .collapsible-fade .collapsible-toggle { transform: translateY(0.3rem); }
    .collapsible-toggle i { font-size: 0.75em; }
    .collapsible-toggle:hover { text-decoration: underline; }
  `]
})
export class CollapsibleComponent implements AfterViewInit, OnDestroy {
  // How tall the content may be before it is cut off
  @Input() max_height = 160;
  // The colour the content fades into - the background it sits on
  @Input() fade_colour = '#ffffff';
  @ViewChild('inner') inner: ElementRef<HTMLElement>;

  expanded = false;
  overflowing = false;
  private observer: ResizeObserver | null = null;

  constructor(private zone: NgZone, private cdr: ChangeDetectorRef) { }

  ngAfterViewInit() {
    this.Measure();
    if (typeof ResizeObserver !== 'undefined') {
      // The content can change height after it first shows (images loading, an edited comment), so it is watched
      this.observer = new ResizeObserver(() => this.zone.run(() => this.Measure()));
      this.observer.observe(this.inner.nativeElement);
    }
  }

  ngOnDestroy() {
    this.observer?.disconnect();
  }

  private Measure() {
    const overflowing = (this.inner?.nativeElement?.offsetHeight || 0) > this.max_height + 24;
    if (overflowing !== this.overflowing) {
      this.overflowing = overflowing;
      this.cdr.detectChanges();
    }
  }
}
